module.exports = __webpack_public_path__ + "img/Bpoint5.04926f8b.png";